import { useMemo } from 'react';

import { useIsCommunityDraftPostEnabled, useIsStorylineDraftPostEnabled } from '../../featureChecks';
import { UseMainUIFeatureSettings } from '../../types';

export const useDraftPostSettings: UseMainUIFeatureSettings<'draftPost'> = (options) => {
  const draftPostOverrides = options?.overrides?.draftPost;

  const isStorylineDraftPostEnabled = useIsStorylineDraftPostEnabled();
  const isCommunityDraftPostEnabled = useIsCommunityDraftPostEnabled();

  return useMemo(
    () => ({
      isStorylineDraftPostEnabled,
      isCommunityDraftPostEnabled,
      ...draftPostOverrides,
    }),
    [draftPostOverrides, isStorylineDraftPostEnabled, isCommunityDraftPostEnabled]
  );
};
